import React from 'react'

import { pxToRem } from '@/shared/styles/themes'
import { styled } from '@mui/material'

export type CheckoutCartWrapperProps = {
  children: React.ReactNode
}

export const CheckoutCartWrapper: React.FC<CheckoutCartWrapperProps> = ({ children, ...props }) => (
  <StyledWrapper {...props}>
    {children}
  </StyledWrapper>
)

const StyledWrapper = styled('div')`
  width: 100%;
  margin-top: ${pxToRem(20)};

  &>div:not(:last-child) {
    border-bottom: 1px solid ${props => props.theme.palette.custom.formFieldBorder};
  }
`

